import CustomizedFields from './CustomizedFields';

export default CustomizedFields;



// WEBPACK FOOTER //
// ./src/models/Fields/index.js